var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFeeCollapseGrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4.5C0.5 2.567 2.067 1 4 1H24C25.933 1 27.5 2.567 27.5 4.5V24.5C27.5 26.433 25.933 28 24 28H4C2.067 28 0.5 26.433 0.5 24.5V4.5Z",
    stroke: "#EA9E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8889 8.38889C14.8889 7.89797 14.4909 7.5 14 7.5C13.5091 7.5 13.1111 7.89797 13.1111 8.38889V13.6111H7.88889C7.39797 13.6111 7 14.0091 7 14.5C7 14.9909 7.39797 15.3889 7.88889 15.3889H13.1111V20.6111C13.1111 21.102 13.5091 21.5 14 21.5C14.4909 21.5 14.8889 21.102 14.8889 20.6111V15.3889H20.1111C20.602 15.3889 21 14.9909 21 14.5C21 14.0091 20.602 13.6111 20.1111 13.6111H14.8889V8.38889Z",
    fill: "#EA9E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeeCollapseGrow);
export default __webpack_public_path__ + "static/media/icon_fee_collapse_grow.b9a610cef5707fca1f9efef27e516471.svg";
export { ForwardRef as ReactComponent };